import React from "react";
import { useLocation, Link } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { FaXmark } from "react-icons/fa6";
import CompanyPosts from "../../../../Components/CompanyPosts";
const PagePosts = () => {

  const location = useLocation();
  let url = location.pathname;


  return (
    <>
      <div className="bg-[#F3F2EF] mt-14 ">
        <div className="container mx-auto py-8 gap-4 sm:px-6">
          <div className="flex px-2">
            <Sidebar />

            {/* Sidebar */}
            {/* Main Content */}
            <div className="flex-1 mx-4">
              <div className="bg-white rounded-lg shadow-md mb-4">
                <div className="p-4">
                <h2 className="text-lg font-semibold text-gray-800">
                    Page posts
                  </h2>
                  <p className="text-gray-500">Manage your page's organic and paid content</p>
                </div>
              
                <div className="flex items-center mt-4">
                  <Link to="/company/page-posts" className={` ${url === "/company/page-posts" ? "border-b-4 border-green-700 text-green-700 font-semibold rounded-lg" : "text-gray-600 font-semibold"}`}>
                  <p className={`text-gray-600 mr-3 px-4 pb-3 ${url === "/company/page-posts" ? "text-green-700 font-semibold rounded-lg" : "text-gray-600 font-semibold"}`}>Published</p>

                  </Link>
                  <Link to="/company/page-ads" className={` ${url === "/company/page-ads" ? "border-b-4 border-green-600 text-green-700 font-semibold" : "text-gray-600 font-semibold"}`}>

                  <p className="text-gray-600 mr-3 px-4 pb-3">Page ads</p>
                  </Link>
                </div>
                
              </div>

              <div className="bg-white rounded-lg shadow p-4 mb-4">
                <div className="flex items-center">
                  <img
                    src="/Images/newsfeed/ProfilePicture.png"
                    alt="User profile"
                    className="rounded-full w-12 h-12"
                  />
                  <input
                    type="text"
                    placeholder="Start a post"
                    className="ml-4 w-full p-2 border rounded-full"
                    // onClick={() => setModalOpen(true)}
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  />
                  {/* {modalOpen && (
                    <PostModal
                      modalOpen={modalOpen}
                      closeModal={() => setModalOpen(false)}
                    />
                  )} */}
                </div>
                <div className="flex justify-around mt-4">
                  <button className="flex items-center text-gray-500">
                  📷{" "}Photo
                  </button>

                  <button className="flex items-center text-gray-500">
                  🎥{" "}Video
                  </button>
                  <button className="flex items-center text-gray-500">
                  📝{" "}Write article
                  </button>
                </div>
              </div>
              <CompanyPosts />

              {/* Ad Section */}
              <div className="bg-white rounded-lg shadow-md p-4 mt-4">
                <div className="flex items-center justify-between ">
                <p className="text-gray-900 text-lg font-semibold">Increase your brand awareness</p>
                <FaXmark className="text-gray-600 cursor-pointer" />
                </div>
                <p className="text-sm text-gray-600 mb-4 mt-2">
                  Learn how to boost reach and brand awareness for your next
                  LinkedIn ads campaign
                </p>
                <button className="font-semibold bg-blue-600 text-white py-1 px-4 text-sm rounded-full mt-2">
                  Learn more
                </button>
              </div>
            </div>

            {/* Right Sidebar */}
            <div className="w-80">
              <div className="bg-white rounded-lg shadow-md p-4 mb-4">
                <h2 className="text-lg font-semibold text-gray-800">
                  Post highlights
                </h2>
                <p className="text-sm text-gray-500 mb-3">
                  In the last 30 days
                </p>
                <p className="text-gray-900 font-semibold mb-1">
                  Most Reactions
                </p>
                <div className="border p-2 rounded-t-lg">
                  <div className="flex items-center mt-2 ">
                    <img
                      src="/Images/newsfeed/image 7.png"
                      alt="Post Image"
                      className="w-16 h-16 rounded-md mr-2"
                    />
                    <p className="text-sm text-gray-700">
                      Smarter Software: The Real Impact of AI in Development
                    </p>
                  </div>
                  <p className="text-gray-500 text-sm mt-1">4 reactions</p>
                </div>
                <div className="flex text-gray-400 items-center gap-2 border-b border-r border-l p-2 rounded-b-lg">
                  <i class="fa fa-lightbulb"></i>
                  <p className="text-gray-600 text-sm">
                    Get up to 240,000 additional impressions.
                  </p>
                  <button className="text-xs border border-blue-600 font-semibold text-blue-600 py-1 px-4 rounded-full mt-2 w-fit">
                    Boost
                  </button>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-md p-4">
                <h2 className="text-lg font-semibold text-gray-800 mb-2">
                  Grow your followers
                </h2>
                <img
                  src="/Images/user-img.jpg"
                  alt="Grow your followers"
                  className="w-8 h-8 object-cover rounded-full mb-2"
                />
                <p className="text-gray-600 mb-2 text-xs">
                  <span className="font-semibold text-gray-500">250/250</span>{" "}
                  credits available
                </p>
                <p className="text-sm text-gray-800">
                  Build your audience & reach by inviting connections to follow
                  your Page
                </p>
                <button className="text-sm border border-blue-600 text-blue-600 py-1 px-4 rounded-full mt-2 w-fit font-semibold">
                  Invite connections
                </button>
              </div>
              <div className="mt-4 text-gray-500 text-sm/7 text-center ">
                <p>About • Accessibility • Help Center</p>
                <p>Privacy & Terms • Ad Choices</p>
                <p>Advertising • Business Services</p>
                <p>Get the LinkedIn app • More</p>

                <div className="mt-2 flex justify-center items-center space-x-2">
                  <img
                    src="/Images/logo/Logo-2 1.png"
                    alt="linkup"
                    className="w-16 h-auto object-contain"
                  />
                  <span className="text-gray-700 text-sm">
                    LogicSpice © 2025
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PagePosts;
